import styled from "styled-components";

export const VideoResponsive = styled.div`
  overflow: hidden;
  padding-bottom: 56.25%;
  position: relative;
  height: 0;
  margin-top: 200px;
`;

export const StyledIframe = styled.iframe`
  left: 50%;
  top: 50%;
  width: 100%;
  height: 100%;
  position: absolute;
  border: none;
  border-radius: 10px;
 @media (max-width: ${({ theme }) => theme.breakpoint.mobile}px) {
    left: 0;
    top: 0;
  }
    @media (min-width: ${({ theme }) => theme.breakpoint.mobile}px) {
      transform: scale(0.8) translate(-50%, -50%);
  transform-origin: top left;
  }
`;